<template>
  <div>
    <div class="box">
      <p class="return" @click="$router.go(-1)">返回</p>
      <span class="line">|</span>
      <p class="contract back"  @click="back">项目列表</p>
      <span class="lines">></span>
      <p class="contract">关联设置</p>
    </div>
    <div class="p_btn">
      <div>
        <div class="mainTitle">乾通嗖嗖关联项目数据设置</div>
        <div class="viceTitle">数据同步将在您设置完成后进行关联</div>
      </div>
    </div>
    <div class="ibox">
      <div class="table">
        <h4 style="font-weight: bold; color: rgba(48, 49, 64, 1)">权限设置</h4>
        <div class="operating"></div>
      </div>
      <div role="tablist" aria-multiselectable="true" class="el-collapse">
        <div class="ssg_title">
          <span style="margin-right: 125px">功能模块</span>
          <span style="margin-right: 20px">页面查看权限</span>
          <span>页面功能权限</span>
        </div>
        <permissionList :treeData="treeData" />
      </div>
    </div>

    <div class="btndiv">
      <button class="btn" tag="button" @click="$router.go(-1)">取消</button>
      <button class="btn subbtn" @click="headSwitch">保存</button>
    </div>
  </div>
</template>

<script>
import permissionList from "../../system/setPower/permissionList.vue";
export default {
  components: {
    permissionList,
  },
  created() {
    //初始化数据
    this.loadData();
    // if (this.$route.query.id) {
    // this.loadEiditPermission();
    // } else {
    //   this.getId(this.permissionList);
    // }
  },
  data() {
    return {
      checks: false,
      detailList: [],
      checkk: [],
      cheks: false,
      choseYes: false,
      listidss: [],
      permissionList: [],
      defaultLists: [],
      listIds: [],
      editInfo: {
        name: "",
      },
      operationName: "",
      data: [],
      operation: [],
      checkOne: [],
      propsa: {
        label: "name",
        value: "id",
        children: "children",
      },
      props: {
        label: "label",
        value: "id",
        children: "children",
      },
      edit: false,
      orgList: [],
      baseInfo: {
        name: "",
        mobile: "",
        email: "",
        orgId: "",
        authority: 1,
      },
      ruless: {
        name: [
          {
            required: true,
            message: "请输入权限组名称",
            trigger: "blur",
          },
        ],
      },

      rules: {
        name: [
          {
            required: true,
            message: "请输入权限组名称",
            trigger: "blur",
          },
        ],
      },

      permissionList: [],
      list_openStatus: [],
      form: {
        values: [],
      },
      treeData: [
        
      ],
      perData: [],
    };
  },
  methods: {
    back() {
        this.$router.push({
        path: "/ssgSplat",
      });
    },

    detailTrees(data, values) {
      // let detailList = []
      // for (var key in data) {
      //     if (data[key].children.length > 0) {
      //         this.detailTrees(data[key].children,values)
      //     }else {
      //         this.detailList.push(data[key].id)

      //     }
      // }
      // let arr = []
      // let parentArr = this.$refs.tree.getHalfCheckedKeys()
      // for(let j of this.detailList) {
      //     for(let i of values) {
      //         if(i == j) {
      //             arr.push(+i)
      //         }
      //     }

      // }
      this.permissionList = data;
      // this.defaultLists = arr
    },

    loadEiditPermission() {
      const params = {
        id: this.$route.query.id,
      };
      this.$axios
        .get(
          "/project/getDataCenterPermissionTree?dcspId=" + this.$route.query.id
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.form.values = [];
            if (res.data.data.values && res.data.data.values.length > 0) {
              res.data.data.values.forEach((v, k) => {
                this.form.values.push(Number(v));
              });
            }
            // this.detailTrees(this.permissionList,arr)
            this.editInfo.name = res.data.data.name;
          }
        });
    },

    checkAllTree(data, list) {
      this.choseYes = true;
      // this.listIds = list.checkedNodes

      let parentArr = this.$refs.tree.getHalfCheckedKeys();
      let childeArr = this.$refs.tree.getCheckedKeys();
      let arr = childeArr.concat(parentArr);
      this.listIds = arr;
    },
    //保存

    addOrg() {
      this.listidss = [];
      if (this.choseYes == true || this.checks == true) {
        let parentArr = this.$refs.tree.getHalfCheckedKeys();
        let childeArr = this.$refs.tree.getCheckedKeys();
        let arr = childeArr.concat(parentArr);
        this.listIds = arr;
        if (this.listIds.length > 0) {
          for (let i of this.listIds) {
            this.listidss.push(i);
          }
        } else if (this.listIds.length == 0) {
          this.listidss == [];
        } else {
          for (let i of this.defaultLists.values()) {
            this.listidss.push(i);
          }
        }
        for (let j of this.checkOne.values()) {
          this.listidss.push(j);
        }
      } else {
        this.listidss = this.permissionList;
      }

      if (!this.edit) {
        this.$refs.baseInfo.validate((status) => {
          if (status == true) {
            this.$axios
              .post(
                "permissionGroup/createPermissionGroup?name=" +
                  this.baseInfo.name +
                  "&values=" +
                  this.listidss
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({
                    path: "/main/system/system/rightsGroups",
                  });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                console.error(err);
              });
          }
        });
      } else if (this.edit) {
        this.$refs.editInfo.validate((status) => {
          if (status == true) {
            this.$axios
              .post(
                "permissionGroup/editPermissionGroup?name=" +
                  this.editInfo.name +
                  "&values=" +
                  this.listidss +
                  "&id=" +
                  this.$route.query.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({
                    path: "/main/system/system/rightsGroups",
                  });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.error(err);
              });
          }
        });
      }
    },

    handleCheckedCitiesChange(data, id) {
      this.cheks = true;
      // this.checkOne = this.checkOne.map(res => {
      //     if (res != this.actionid) {
      //         return res;
      //     }
      // });
    },
    handleCheckChange(data, checked, indeterminate) {},
    handleNodeClick(data) {},
    handleCheckon(data) {
      this.operationName = data.name;
      this.checks = true;

      //查询某一个权限
      this.$axios
        .get("/permission/findByParentId?parentId=" + data.id + "&type=" + 1)
        .then((res) => {
          if (res.data.status === 1) {
            this.operation = res.data.data;
            for (var i = 0; i < this.permissionList.length; i++) {
              for (var j = 0; j < this.operation.length; j++) {
                if (this.permissionList[i] == this.operation[j].id) {
                  this.checkk = [];
                  this.checkk.push(this.permissionList[i]);
                  this.checkOne.push(+this.permissionList[i]);
                }
              }
            }
          } else {
            this.$message.error("查询组织列表请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    change(item) {
      let checked = item.switched;
      if (checked) {
        this.form.values.push(item.id);
        if (item.views && item.views.length > 0) {
          item.views.forEach((element) => {
            element.switched = true;
            this.form.values.push(element.id);
            if (element.funcs.length > 0) {
              element.funcs.forEach((func) => {
                this.form.values.push(func.id);
              });
            }
            if (element.views && element.views.length > 0) {
              element.views.forEach((view) => {
                view.switched = true;
                this.form.values.push(view.id);
                if (view.funcs.length > 0) {
                  view.funcs.forEach((func) => {
                    this.form.values.push(func.id);
                  });
                }
              });
            }
          });
        }
        if (item.funcs.length > 0) {
          item.funcs.forEach((func) => {
            this.form.values.push(func.id);
          });
        }
      } else {
        this.form.values.splice(
          this.form.values.findIndex((v) => v == item.id),
          1
        );
        if (item.views && item.views.length > 0) {
          item.views.forEach((element) => {
            if (element.funcs.length > 0 && element.switched) {
              element.funcs.forEach((func) => {
                if (this.form.values.findIndex((v) => v == func.id) != -1) {
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == func.id),
                    1
                  );
                }
              });
              this.form.values.splice(
                this.form.values.findIndex((v) => v == element.id),
                1
              );
            }
            element.switched = false;
            if (element.views && element.views.length > 0) {
              element.views.forEach((view) => {
                if (view.funcs.length > 0 && view.switched) {
                  view.funcs.forEach((func) => {
                    if (this.form.values.findIndex((v) => v == func.id) != -1) {
                      this.form.values.splice(
                        this.form.values.findIndex((v) => v == func.id),
                        1
                      );
                    }
                  });
                  this.form.values.splice(
                    this.form.values.findIndex((v) => v == view.id),
                    1
                  );
                }
                view.switched = false;
              });
            }
          });
        }
        if (item.funcs.length > 0) {
          item.funcs.forEach((func) => {
            if (this.form.values.findIndex((v) => v == func.id) != -1) {
              this.form.values.splice(
                this.form.values.findIndex((v) => v == func.id),
                1
              );
            }
          });
        }
      }
    },

    open_list(index) {
      this.list_openStatus[index] = !this.list_openStatus[index];
      this.$forceUpdate();
    },
    setPermission() {
      if (!this.edit) {
        this.$refs.baseInfo.validate((status) => {
          if (status == true) {
            this.$axios
              .post(
                "permissionGroup/createPermissionGroup?name=" +
                  this.baseInfo.name +
                  "&values=" +
                  this.form.values
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({
                    path: "/main/system/system/rightsGroups",
                  });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                console.error(err);
              });
          }
        });
      } else if (this.edit) {
        this.$refs.editInfo.validate((status) => {
          if (status == true) {
            this.$axios
              .post(
                "permissionGroup/editPermissionGroup?name=" +
                  this.editInfo.name +
                  "&values=" +
                  this.form.values +
                  "&id=" +
                  this.$route.query.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({
                    path: "/main/system/system/rightsGroups",
                  });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.error(err);
              });
          }
        });
      }
    },

    // 加载树列表
    loadData() {
      let url = "";

      url =
        "project/getDataCenterPermissionTree?dcspId=" + this.$route.query.id;

      this.$axios
        .get(url)
        .then((res) => {
          this.treeData = res.data.data;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    headSwitch() {
      console.log(this.treeData);
      this.perData = [];
      this.treeData.map((item) => {
        if (item.switched) {
          this.perData.push(item.id);
          if (item.views.length > 0) {
            this.recursion(item.views);
          }
          if (item.funcsId) {
            if (item.funcsId.length > 0) {
              this.perData.push(...item.funcsId);
            }
          }
        }
      });
      console.log(this.perData);
      this.saveData();
    },
    recursion(datas) {
      if (datas) {
        datas.map((item) => {
          if (item.switched) {
            this.perData.push(item.id);
            if (item.views.length > 0) {
              this.recursion(item.views);
            }
            if (item.funcsId) {
              if (item.funcsId.length > 0) {
                this.perData.push(...item.funcsId);
              }
            }
          }
        });
      }
    },
    saveData() {
      this.$axios
        .post(
          "project/updateDataCenterPermissionUser?dcspId=" +
            this.$route.query.id +
            "&permissionIds=" +
            this.perData
        )
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success(res.data.message);
            this.$router.push({
              path: "/ssgSplat/settings/employPlatform",
              query: {
                id: this.$route.query.ssgId,
              },
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          //处理错误
          this.maskshow = false;
          console.log(err);
        });
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;
  // margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 24px 0 15px 0;
}
.viceTitle {
  font-size: 12px;
  font-weight: 400;
  color: #8a8a9a;
  line-height: 18px;
}

.contree {
  width: 100%;
  height: 740px;
  border-radius: 4px;
  border: 1px solid rgba(216, 218, 225, 1);
  display: flex;
}

.trees {
  width: 50%;
  height: 700px;
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid #d8dae1;
}

.edit {
  width: 50%;
  height: 740px;
  background: rgba(247, 248, 252, 1);
}

.table {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 34px 34px 0;

  h4 {
    font-size: 14px;
    font-weight: bold;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 8px;
    color: #303140;
  }

  h4:before {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    width: 4px;
    height: 12px;
    background-color: #6669e3;
    border-radius: 4px;
  }
}

.gettree {
  margin-left: 34px;
}

.mytree {
  margin-left: 10px;

  .first {
    margin-left: 10px;
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.mytree[data-v-e8abc770] .el-tree .el-tree-node:before {
  border-left: 0px solid #d8dae1;
  bottom: 0px;
  height: 100%;
  top: -17px;
  width: 1px;
}

.mytree /deep/ .el-tree {
  > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
    background-color: #eee;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #d8dae1;
    bottom: 0px;
    height: 100%;
    top: -17px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #d8dae1;
    height: 20px;
    top: 21px;
    width: 24px;
  }

  .el-tree .is-current:after {
    background-color: transparent;
  }
}

.edut {
  margin-left: 40px;

  .fontName {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
    margin-bottom: 20px;
  }
}

.btndiv {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  .subbtn {
    margin-left: 10px;
  }
}

.el-form-item:first-child {
  margin-top: 22px;
}

.module_left_line {
  font-size: 12px;
  margin-left: 25px;
  border-left: 1px solid #d9dbe2;
  font-weight: bold;
}

.module_left {
  margin-left: 20px;
  display: inline-flex;
  margin-top: 20px;
  position: relative;
}

.module_name {
  width: 100px;
  position: relative;
}

.module_line {
  position: absolute;
  border: 0.5px solid #d9dbe2;
  width: 15px;
  left: -20px;
  top: 8px;
}

.child_moudle_left_line {
  border-left: 1px solid #d9dbe2;
  margin-left: 29px;
  display: flex;
  flex-direction: column;
}

.child_moudle_left {
  display: inline-flex;
  margin-left: 15px;
  margin-top: 20px;
  position: relative;
}

.child_moudle_name {
  width: 52px;
  position: relative;
}

.child_module_line {
  position: absolute;
  border: 0.5px solid #d9dbe2;
  width: 15px;
  left: -15px;
  top: 8px;
}

.module_last_cover {
  width: 10px;
  height: 10000px;
  display: block;
  position: absolute;
  left: -30px;
  top: 9px;
  background: white;
}

.child_module_last_cover {
  display: block;
  height: 10000px;
  width: 10px;
  position: absolute;
  left: -20px;
  top: 9px;
  background: white;
}

.ssg_title {
  padding-left: 20px;
  margin-bottom: 10px;

  span {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.ssg_title span {
  margin-right: 66px;
}

.el-checkbox__label {
  font-size: 12px;
  font-weight: bold;
}

.el-checkbox-group {
  display: contents;
}

.el-checkbox-group label {
  /* margin-left: 10px; */
  margin-right: 15px;
  width: 120px;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6669e3;
  border-color: #6669e3;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}

.el-icon-arrow-right:before {
  content: "\E604";
  color: white;
}

.el-collapse {
  border: 0;
}

.el-collapse-item__header {
  color: #6669e3;
  font-weight: bold;
  padding-left: 20px;
  border: 0;
  position: relative;
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header {
  background-color: rgb(248, 250, 251);
}

.el-carousel__mask,
.el-cascader-menu,
.el-cascader-menu__item.is-disabled:hover,
.el-collapse-item__header,
.el-collapse-item__wrap {
  background-color: whtie;
}

.el-collapse-item {
  margin-bottom: 15px;
}

.el-collapse-item.is-active {
  border: 1px solid #b2b5ef;
}

.el-collapse-item:last-child {
  margin-bottom: 10px;
}

.el-switch__label--left {
  margin-right: 0;
}

.el-switch__label--right {
  margin-left: 0;
}

.el-switch__label.is-active {
  color: #fff;
}

.el-switch__label {
  color: #fff;
}

.el-switch__core {
  height: 25px;
  border-radius: 15px;
}

.el-switch {
  line-height: 25px;
  height: 25px;
}

.el-switch__label {
  position: absolute;
  /*left: 20%;*/
  /*margin-left: -18px;*/
  height: 25px;
}

.el-switch__label.is-active {
  left: 20%;
}

.el-switch__label--right {
  left: 40%;
}

.el-switch__core:after {
  width: 21px;
  height: 21px;
}

.el-switch.is-checked .el-switch__core::after {
  margin-left: -23px;
}

.el-switch__label * {
  font-size: 12px;
}

// 	.custombtn {
// 		position: absolute;
// 		top: 10px;
// 		right: 10px;
// 	}

.group {
  margin-bottom: 20px;
  background-color: #f2f5f8;
  padding-top: 10px;
  padding-bottom: 20px;
  border-radius: 10px;
  width: 70%;
  margin-left: 15%;
}

.menu {
  margin-bottom: 10px;
  border-bottom: 1px solid #dadee2;
  padding-left: 20px;
  padding-bottom: 10px;
}
.customize {
  width: 100%;
  margin-bottom: 20px;
  .item {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 100px;
    box-sizing: border-box;
    .title {
      min-width: 100px;
      font-size: 14px;
    }

    .btn {
      min-width: 120px;
      padding: 0 8px;
    }

    .statistics {
      font-size: 14px;
      color: #6668e3;
      margin-left: 20px;
    }
  }
  .blockdiv {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      font-size: 14px;
      margin: 0 10px 0 16px;
    }
    div {
      padding: 2px 8px;
      background-color: rgb(136, 136, 136);
      font-size: 12px;
      margin-right: 8px;
      border-radius: 4px;
      color: #fff;
      margin-top: 10px;
      i {
        cursor: pointer;
      }
    }
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  .left {
    display: flex;
    align-items: center;
  }
  .company {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 64, 1);
    margin-right: 30px;
  }
  .line {
    width: 1px;
    height: 21px;
    background-color: #d9dbe2;
    margin: 0 37px;
  }
  .back {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    cursor: pointer;
  }
  .logo {
    margin-left: 30px;
  }
}
.box {
  display: flex;
  //   margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}
</style>
